import { useContext, useEffect, useState } from "react";

import { CreateChannelContext } from "../../../context/CreateChannelContext";
import { ChannelState, SKChannel, Tier } from "../../../models/SKChannel";
import ImageInput from "../../artifacts/create/ImageInput";
import VideoInput from "../../artifacts/create/VideoInput";
import { FolderName } from "../../../api/shared/uploadService";
import { AddTextField } from "../../../components/AddTextField";
import OptionSelect from "../../../components/OptionSelect";

interface PublishingTiersProps {
  index: number;
  disabled?: boolean;
  channelData: SKChannel;
  updateChannelData?: React.Dispatch<React.SetStateAction<SKChannel>>;
}

export const ChannelSubscriptionType = ({ index, disabled = false, channelData, updateChannelData }: PublishingTiersProps) => {
  // const { channelData, updateChannelData, originalState } = useContext(CreateChannelContext);
  const [errors, setErrors] = useState<{ [key: string]: string | undefined }>({});
  //const [editable, setEditable] = useState<boolean>(true);
  interface SubscritionType {
    text: string;
    note: string;
    type?: Tier | undefined;
  }
  const data: SubscritionType[] = [
    { text: "Free only", type: Tier.free, note: "All content on this channel will be available for free." },
    { text: "Subscription Only", type: Tier.paid, note: "Only paid subscribers will be able to access your content." },
    { text: "Free and Subscription Both", type: Tier.freeNpaid, note: "Offer a mix of free and premium content." },
  ];

  const getImage = (tier?: Tier) => {
    if (tier) {
      if (channelData.subscriptionStatus && channelData.subscriptionStatus === tier) {
        return !disabled ? "/icons/CheckFilled.png" : "/icons/checkeditem.png";
      }
    } else {
      if (!channelData.subscriptionStatus) {
        return !disabled ? "/icons/CheckFilled.png" : "/icons/checkeditem.png";
      }
    }

    return "/icons/CheckInactive.png";
  };

  const handleFileChange = (fileUrl: string | null) => {
    if (fileUrl) {
      updateChannelData && updateChannelData(prev => ({ ...prev, subscriptionVideoUrl: fileUrl }));
    } else {
      const { subscriptionVideoUrl, ...rest } = channelData;
      updateChannelData && updateChannelData(rest);
    }
  };
  const handleImageChange = (index: number, fileUrl: string | null) => {
    updateChannelData && updateChannelData(prev => ({ ...prev, subscriptionImageUrl: fileUrl ?? undefined }));
  };

  return (
    <div>
      <div className="relative w-full min-w-[200px]">
        <div className="flex items-center">
          {index && <span className="content_count">{index}</span>}
          <span className="content_title">Content Access</span>
        </div>
        <div className="notes-class-wo-btm-space ">Choose how you'll offer content on your channel.</div>

        {data.map((item, idx) => (
          <div
            tabIndex={0}
            onClick={() => {
              if (!disabled) {
                updateChannelData &&
                  (item.type
                    ? updateChannelData(prev => ({
                        ...prev,
                        subscriptionStatus: item.type,
                      }))
                    : updateChannelData(prev => {
                        const { subscriptionStatus, subscriptionImageUrl, subscriptionVideoUrl, ...rest } = prev;
                        return rest;
                      }));
              }
            }}
            key={idx}
            className="border-skseparatorgray max-w-[480px] border-b-[1px] pt-[15px] pb-[15px] flex flex-row w-full items-center cursor-pointer"
          >
            <div>
              <img
                src={item.type ? getImage(item.type) : getImage()}
                className="object-contain w-[22px] h-[22px] min-w-5"
                alt={`Tier status for ${item.text}`}
              />
            </div>

            <span className="capitalize radio-button-choose">{item.text}</span>
          </div>
        ))}
      </div>
    </div>
  );
};
